import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";

import { allSharedComponents } from "../..";
import { authActions, UserActions, SpotActions } from "../../../redux/actions";
import { sportNames } from "../../../modules/AdminPortal/Views/Spots/utilities";
import {
  translationConstants,
  fieldLengthConstants,
  Directions,
  globalConstants,
  Regex,
  relativeToShoreOptions,
  windDirectionsOptions
} from "../../../constants";
import FindOnMapModal from "../Modals/FindOnMapModal";

const { SpinnerContainer, CustomModal } = allSharedComponents;

const ViewSpotModal = (props) => {
  const { Mandatory_Character } = globalConstants;

  const dispatch = useDispatch();
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  const userDataObj = useSelector((state) => state.SpotsReducer?.spotDataById);
  const cities = useSelector((state) => state.LoginReducer.cities);
  const userData = userDataObj.spotInfo;

  const [isEditMode, setIsEditMode] = useState(
    props.isEditMode || props.isAddMode
  );
  const [selectedCity, setSelectedCity] = useState("");
  const [isAtLeastOneChecked, setIsAtLeastOneChecked] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [selectedSports, setSelectedSports] = useState({});
  const [lng, setLng] = useState("");
  const [lat, setLat] = useState("");

  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    getValues,
  } = useForm();
  const { t } = useTranslation();

  const onSubmit = (data) => {
    const selectedSportIds = Object.entries(selectedSports)
      .filter(([id, isSelected]) => isSelected)
      .map(([id]) => parseInt(id));

    const isSpotSelected = selectedSportIds.length > 0;
    setIsAtLeastOneChecked(isSpotSelected);
    setIsFormSubmitted(true);

    if (!isSpotSelected) {
      return;
    }

    const dataToSend = {
      spotInfo: {
        name: data.spotName,
        arabicName: data.spotNameArabic,
        locationName: data.spotLocationName,
        arabicLocationName: data.spotLocationNameArabic,
        lat: lat?.toString(),
        long: lng?.toString(),
        usualWindDrection: data.usualWindDirections,
        preferredWindDrection: data.preferredWindDirection,
        windSeason: data.windSeasons,
        nearWindSensorURL: data.nearWindSensorsLink,
        windForecastURL: data.linkToWindForecasts,
        relativeToShore: data.relativeToShore,
        cityId: parseInt(selectedCity),
        isActive: userData?.isActive,
        entryFee: userData?.entryFee,
        spotTypeId: 0,
      },
      sportIds: selectedSportIds,
      id: userDataObj?.id,
    };

    if (props.isAddMode) {
      dispatch(
        SpotActions.addPublicSpot(dataToSend, props.gridState, props.setShow)
      );
    } else if (props.isEditMode || (props.isViewMode && isEditMode)) {
      dispatch(
        SpotActions.updatePublicSpot(dataToSend, props.gridState, props.setShow)
      );
    }
  };

  const cancelUpdateuser = () => {
    props.setShow((prev) => !prev);
    dispatch(UserActions.OpenModal(false));
  };

  useEffect(() => {
    //Set initial form values from selected spot
    if (props.isEditMode || props.isViewMode) {
      setValue("spotName", userData?.name);
      setValue("spotNameArabic", userData?.arabicName);
      setValue("spotLocationName", userData?.locationName);
      setValue("spotLocationNameArabic", userData?.arabicLocationName);
      setValue("latitude", userData?.lat);
      setValue("longitude", userData?.long);
      setValue("usualWindDirections", userData?.usualWindDrection);
      setValue("relativeToShore", userData?.relativeToShore);
      setValue("preferredWindDirection", userData?.preferredWindDrection);
      setValue("windSeasons", userData?.windSeason);
      setValue("nearWindSensorsLink", userData?.nearWindSensorURL);
      setValue("linkToWindForecasts", userData?.windForecastURL);
      setValue("spotcity", userData?.cityId);
      const centerName = userDataObj?.centers && userDataObj?.centers[0]?.name;
      setValue("centerName", centerName);
      setValue("entryFees", userData?.entryFee);
      setValue("isEntryFees", userData?.entryFee ? true : false);
      setValue("canBringOwnEquipment", userData?.hasOwnEquipment);

      //Set suitable sports
      const selectedSportIds = userDataObj?.sportIds || [];
      const selectedSports = Object.fromEntries(
        selectedSportIds.map((id) => [id, true])
      );
      setSelectedSports(selectedSports);

      //Fetch cities against country Saudi Arabia
      setSelectedCity(userData?.cityId);
      setLat(userData?.lat);
      setLng(userData?.long);
    }

    // eslint-disable-next-line
  }, [userData]);

  useEffect(() => {
    //Fetch cities against country Saudi Arabia
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));

    // eslint-disable-next-line
  }, []);

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  const handleCheckboxChange = (id) => {
    setSelectedSports((prevSelected) => ({
      ...prevSelected,
      [id]: !prevSelected[id],
    }));
  };

  const getModalTitle = () => {
    switch (true) {
      case props.isAddMode:
        return props.isPrivateSpot
          ? t(translationConstants.CREATE_PRIVATE_SPOT)
          : t(translationConstants.CREATE_PUBLIC_SPOT);
      case props.isPrivateSpot && isEditMode:
        return t(translationConstants.EDIT_PRIVATE_SPOT);
      case props.isPrivateSpot:
        return t(translationConstants.VIEW_PRIVATE_SPOT);
      case isEditMode:
      case props.isEditMode:
        return t(translationConstants.EDIT_PUBLIC_SPOT);
      default:
        return t(translationConstants.VIEW_PUBLIC_SPOT);
    }
  };

  const handleSaveLocation = () => {
    setValue("latitude", lat);
    setValue("longitude", lng);
    trigger("latitude");
    trigger("longitude");
    setShowMap(false);
  };

  const [isShowMap, setShowMap] = useState(false);
  const onSetShowMap = () => {
    const { latitude, longitude } = getValues();
    setLat(latitude);
    setLng(longitude);
    setShowMap((prev) => !prev);
  };

  return (
    <div style={{ backgroundColor: "#EBEFE3" }}>
      <Form
        noValidate
        className="ViewUserContent p-4 mx-4"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="ViewHeader">
          <p className="viewUserPara">{getModalTitle()}</p>

          <p className="editButton edit-text-align" onClick={toggleEditMode}>
            {isEditMode || props.isEditNotAllowed ? (
              ""
            ) : (
              <>
                {t(translationConstants.edit)}{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  className="edit-icon-align"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.5833 24.167V15.7087H24.1667V24.167H4.83332V4.83366H13.2917V2.41699H4.83332C3.49863 2.41699 2.41666 3.49897 2.41666 4.83366V24.167C2.41666 25.5017 3.49863 26.5837 4.83332 26.5837H24.1667C25.5013 26.5837 26.5833 25.5017 26.5833 24.167ZM23.1735 3.29113C22.6197 2.73287 21.8613 2.41699 21.0701 2.41699C20.2799 2.41699 19.5223 2.73216 18.9653 3.29258L8.85284 13.4049C7.94921 14.2011 7.35685 15.3858 7.25391 16.66L7.24999 20.5448V21.7531H12.246C13.6166 21.6591 14.813 21.061 15.657 20.0874L25.7121 10.0365C26.27 9.47869 26.5834 8.72206 26.5834 7.93313C26.5834 7.1442 26.27 6.38757 25.7121 5.82971L23.1735 3.29113ZM12.1606 19.3395C12.8062 19.2938 13.407 18.9934 13.8895 18.4415L21.2143 11.1167L17.8862 7.78836L10.5078 15.1644C10.0182 15.5974 9.71536 16.2031 9.66666 16.7573V19.3372L12.1606 19.3395ZM19.5954 6.0798L22.9232 9.40782L24.0033 8.3277C24.1079 8.22305 24.1667 8.08112 24.1667 7.93313C24.1667 7.78514 24.1079 7.6432 24.0033 7.53856L21.4613 4.99661C21.3579 4.89232 21.217 4.83366 21.0701 4.83366C20.9232 4.83366 20.7824 4.89232 20.6789 4.99661L19.5954 6.0798Z"
                    fill="#007F58"
                  />
                </svg>
              </>
            )}
          </p>
        </div>
        <p className="horizentalLine" />

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.SPOT_NAME)}:{Mandatory_Character}
            </Form.Label>
            <Form.Control
              {...register("spotName", {
                required: t(translationConstants.SPOT_NAME_REQUIRED),
              })}
              id="spotName"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              disabled={!isEditMode}
              type="text"
            />
            {errors.spotName && (
              <p className="errorText">{errors.spotName.message}</p>
            )}
          </Form.Group>

          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.SPOT_NAME)}
              <span className="text-black">
                ({t(translationConstants.ARABIC)}):
                <span className="greenColor">
                  {t(translationConstants.optional)}
                </span>
              </span>
            </Form.Label>
            <Form.Control
              dir={Directions.rtl}
              {...register("spotNameArabic")}
              id="spotNameArabic"
              disabled={!isEditMode}
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
            />
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.SPOT_LOCATION_NAME)}:{Mandatory_Character}
            </Form.Label>
            <Form.Control
              {...register("spotLocationName", {
                required: t(translationConstants.SPOT_LOCATION_REQUIRED),
              })}
              id="spotLocationName"
              maxLength={fieldLengthConstants.LOCATION_FIELD_LENGTH}
              disabled={!isEditMode}
              type="text"
            />
            {errors.spotLocationName && (
              <p className="errorText">{errors.spotLocationName.message}</p>
            )}
          </Form.Group>
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.SPOT_LOCATION_NAME)}
              <span className="text-black">
                ({t(translationConstants.ARABIC)}):
              </span>
              <span className="greenColor">
                {t(translationConstants.optional)}
              </span>
            </Form.Label>
            <Form.Control
              dir={Directions.rtl}
              {...register("spotLocationNameArabic")}
              id="spotLocationNameArabic"
              disabled={!isEditMode}
              maxLength={fieldLengthConstants.LOCATION_FIELD_LENGTH}
              type="text"
            />
          </Form.Group>
        </div>

        <div className="row mb-4">
          <Form.Group className="mt-2 col-12 col-lg-6 pe-0 position-relative">
            <Form.Label className="Form-labels">
              {t(translationConstants.SPOT_COORDINATES)}:{Mandatory_Character}
              <span className="greenColor">
                ({t(translationConstants.LAT_LONG)})
              </span>
            </Form.Label>

            <div className="row me-lg-0">
              <Form.Group className="mt-2 col-lg-6 position-relative">
                <Form.Control
                  {...register("latitude", {
                    required: t(translationConstants.LAT_REQUIRED),
                    pattern: {
                      value: /^-?([1-8]?[0-9](\.\d+)?|90(\.0+)?)$/,
                      message: t(
                        translationConstants.LAT_RANGE_VALIDATION_TEXT
                      ),
                    },
                  })}
                  id="latitude"
                  disabled={!isEditMode}
                  type="text"
                  onChange={(e) => {
                    const value = e.target.value;
                    setLat(value);
                  }}
                />
                {errors.latitude && (
                  <p className="errorText">{errors.latitude.message}</p>
                )}
              </Form.Group>
              <Form.Group className="mt-2 col-lg-6 position-relative ps-lg-0">
                <Form.Control
                  {...register("longitude", {
                    required: t(translationConstants.LNG_REQUIRED),
                    pattern: {
                      value:
                        /^-?((([1-9]?[0-9]|1[0-7][0-9])(\.\d+)?)|180(\.0+)?)$/,
                      message: t(
                        translationConstants.LNG_RANGE_VALIDATION_TEXT
                      ),
                    },
                  })}
                  id="longitude"
                  disabled={!isEditMode}
                  type="text"
                  onChange={(e) => {
                    const value = e.target.value;
                    setLng(value);
                  }}
                />
                {errors.longitude && (
                  <p className="errorText">{errors.longitude.message}</p>
                )}
              </Form.Group>
            </div>
          </Form.Group>

          {!props.isPrivateSpot && (
            <div className="col-12 col-lg-6 d-flex d-lg-block justify-content-center">
              <Form.Group className="mt-lg-4 position-relative">
                <Form.Label className="Form-labels"></Form.Label>
                <br />
                <Button
                  className="find-on-map-button mt-2 ms-0 back-none"
                  type="button"
                  disabled={!isEditMode}
                  onClick={onSetShowMap}
                >
                  {t(translationConstants.FIND_ON_MAP)}
                </Button>
              </Form.Group>
            </div>
          )}
        </div>

        <div className="row mb-4 marginTop">
          <Form.Group className="mt-2 col-6 col-lg-3 pe-0 position-relative">
            <Form.Label className="Form-labels">
              {t(translationConstants.PREVAILING_WIND_DIRECTION)}:
              {Mandatory_Character}
            </Form.Label>
            <Form.Select
              {...register("usualWindDirections", {
                required: t(
                  translationConstants.PREVAILING_WIND_DIRECTION_REQUIRED
                ),
              })}
              disabled={!isEditMode}
              aria-label="Default select example"
            >
              <option value="">
                {t(translationConstants.PREVAILING_WIND_DIRECTION)}
              </option>

              {windDirectionsOptions.map((direction) => (
                <option key={direction.id} value={direction.value}>
                  {direction.label}
                </option>
              ))}
            </Form.Select>
            {errors.usualWindDirections && (
              <p className="errorText">{errors.usualWindDirections.message}</p>
            )}
          </Form.Group>

          <Form.Group className="mt-2 col-6 col-lg-3 position-relative">
            <Form.Label className="Form-labels">
              {t(translationConstants.RELATIVE_TO_SHORE)}:{Mandatory_Character}
            </Form.Label>
            <Form.Select
              {...register("relativeToShore", {
                required: t(translationConstants.RELATIVE_TO_SHORE_REQUIRED),
              })}
              disabled={!isEditMode}
              aria-label="Relative to shore select"
            >
              <option value="">
                {t(translationConstants.RELATIVE_TO_SHORE)}
              </option>

              {relativeToShoreOptions.map((option) => (
                <option key={option.id} value={option.value}>
                  {t(option.label)}
                </option>
              ))}
            </Form.Select>
            {errors.relativeToShore && (
              <p className="errorText">{errors.relativeToShore.message}</p>
            )}
          </Form.Group>

          <Form.Group className="mt-2 col-lg-6  position-relative">
            <Form.Label className="Form-labels">
              {t(translationConstants.PREFERRED_WIND_DIRECTION)}:
              {Mandatory_Character}
            </Form.Label>
            <Form.Select
              {...register("preferredWindDirection", {
                required: t(
                  translationConstants.PREFERRED_WIND_DIRECTION_REQUIRED
                ),
              })}
              disabled={!isEditMode}
              aria-label="Default select example"
            >
              <option value="">
                {t(translationConstants.PREFERRED_WIND_DIRECTION)}
              </option>

              {windDirectionsOptions.map((direction) => (
                <option key={direction.id} value={direction.value}>
                  {direction.label}
                </option>
              ))}
            </Form.Select>
            {errors.preferredWindDirection && (
              <p className="errorText">
                {errors.preferredWindDirection.message}
              </p>
            )}
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.WIND_SEASONS)} :{" "}
              <span className="greenColor">
                {t(translationConstants.optional)}
              </span>
            </Form.Label>{" "}
            <Form.Control
              {...register("windSeasons")}
              id="windSeasons"
              disabled={!isEditMode}
              type="text"
            />
          </Form.Group>
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.NEAR_WIND_SENSORS_LINK)}:{" "}
              <span className="greenColor">
                {t(translationConstants.optional)}
              </span>
            </Form.Label>
            <Form.Control
              {...register("nearWindSensorsLink", {
                pattern: {
                  value: Regex.urlRegex,
                  message: t(translationConstants.URL_VALIDATION),
                },
              })}
              id="nearWindSensorsLink"
              disabled={!isEditMode}
              type="text"
            />
            {errors.nearWindSensorsLink && (
              <p className="errorText">{errors.nearWindSensorsLink.message}</p>
            )}
          </Form.Group>
        </div>
        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.LINK_TO_WIND_FORECASTS)}:
              {Mandatory_Character}
            </Form.Label>
            <Form.Control
              {...register("linkToWindForecasts", {
                required: t(
                  translationConstants.LINK_TO_WIND_FORECASTS_REQUIRED
                ),
                pattern: {
                  value: Regex.urlRegex,
                  message: t(translationConstants.URL_VALIDATION),
                },
              })}
              id="linkToWindForecasts"
              disabled={!isEditMode}
              type="text"
            />
            {errors.linkToWindForecasts && (
              <p className="errorText">{errors.linkToWindForecasts.message}</p>
            )}
          </Form.Group>

          {cities.length > 0 && (
            <Form.Group className="form-group-register">
              <Form.Label htmlFor="spotCitySelect" className="Form-labels">
                {t(translationConstants.CITY)}:{Mandatory_Character}
              </Form.Label>
              <Form.Select
                id="spotCitySelect"
                disabled={!isEditMode}
                {...register("spotcity", {
                  required: t(translationConstants.CITY_IS_REQUIRED),
                })}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue("spotcity", value, { shouldValidate: true });
                  setSelectedCity(value);
                  trigger("spotcity");
                  e.stopPropagation();
                }}
                aria-label="Default select example"
              >
                <option value="">{t(translationConstants.selectcity)}</option>
                {cities?.map((city) => (
                  <option key={city.id} value={city.id}>
                    {direction === Directions.rtl ? city.arabicName : city.name}
                  </option>
                ))}
              </Form.Select>
              {errors.spotcity && (
                <p className="errorText">{errors.spotcity.message}</p>
              )}
            </Form.Group>
          )}
        </div>
        {!props.isPrivateSpot && (
          <>
            <div className="inputRow">
              <Form.Group className=" form-group-register" controlId="sailing">
                <Form.Label className="Form-labels">
                  {t(translationConstants.SUITABLE_SPOTS)}:{Mandatory_Character}
                </Form.Label>
              </Form.Group>
            </div>
            <div className="suitableSpotsHead row mx-0 col-lg-8">
              {Object.keys(sportNames).map((id) => (
                <Form.Group
                  key={id}
                  className="col-lg form-group-register my-0 px-0"
                  controlId={id}
                >
                  <Form.Check
                    className="custom-checkbox custom-checkboxInput"
                    type="checkbox"
                    label={t(sportNames[id])}
                    {...register(sportNames[id].toLowerCase())}
                    disabled={!isEditMode}
                    checked={selectedSports[id]}
                    onChange={() => handleCheckboxChange(id)}
                  />
                </Form.Group>
              ))}
            </div>
            {!isAtLeastOneChecked && isFormSubmitted && (
              <p className="errorText">
                {t(translationConstants.SUITABLE_SPOT_REQUIRED)}
              </p>
            )}
          </>
        )}

        {props.isPrivateSpot && (
          <>
            <div className="inputRow">
              <div className="suitableSpotsHead mx-0 col-12">
                <Form.Label className="Form-labels">
                  {t(translationConstants.SUITABLE_SPOTS)}:
                </Form.Label>
                {userDataObj?.sportIds?.map((id) => (
                  <Form.Group
                    key={id}
                    className="col form-group-register my-0 px-0"
                    controlId={id}
                  >
                    <Form.Check
                      className="custom-checkbox custom-checkboxInput"
                      type="checkbox"
                      label={t(sportNames[id])}
                      {...register(sportNames[id].toLowerCase())}
                      disabled={!isEditMode}
                      checked={selectedSports[id]}
                    />
                  </Form.Group>
                ))}
                <div className="row mx-0 col-12 align-items-center">
                  <Form.Group
                    key="isEntryFees"
                    className="col-md-4 position-relative mt-0 mb-2 px-0"
                    controlId="isEntryFees"
                  >
                    <Form.Check
                      className="custom-checkbox custom-checkboxInput"
                      type="checkbox"
                      label={t(translationConstants.ENTRY_FEES)}
                      {...register("isEntryFees")}
                      disabled={!isEditMode}
                      defaultChecked={userData?.entryFee ? true : false}
                    />
                  </Form.Group>

                  <Form.Group className="col-md-4 position-relative mt-0 mb-2 px-0 mx-md-4">
                    <Form.Control
                      {...register("entryFees", {})}
                      id="entryFees"
                      disabled={!isEditMode}
                      type="text"
                    />
                    {errors.entryFees && (
                      <p className="errorText">{errors.entryFees.message}</p>
                    )}
                  </Form.Group>
                </div>
                <Form.Group className="col position-relative mt-0 mb-2">
                  <div className="custom-radio">
                    <Form.Check
                      {...register("canBringOwnEquipment")}
                      type="radio"
                      id="canBringOwnEquipment"
                      label={t(translationConstants.CAN_BRING_EQUIPMENT)}
                      checked={userData?.hasOwnEquipment || false}
                      disabled={!isEditMode}
                    />
                  </div>
                </Form.Group>
              </div>
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.CENTER)}:
                </Form.Label>
                <Form.Control
                  {...register("centerName", {})}
                  id="centerName"
                  disabled={true}
                  type="text"
                />
              </Form.Group>
            </div>
          </>
        )}

        {props.isAddMode ? (
          <>
            <div className="row d-flex justify-content-center mt-4">
              <div className="col-md-3 col-12">
                <Button
                  className="UpdateUserView-button"
                  type="submit"
                >
                  {
                    t(translationConstants.submit)
                  }
                </Button>
              </div>
            </div>
          </>
        ) : (
          isEditMode && (
            <>
              <div className="inputRow">
                <div className="col-12 d-flex justify-content-lg-end justify-content-center">
                  <Button
                    className="update-button max-width-btn"
                    type="submit"
                  >
                    {
                      t(translationConstants.Update)
                    }
                  </Button>
                </div>

                <div className="col-12 d-flex justify-content-lg-start justify-content-center">
                  <button
                    onClick={cancelUpdateuser}
                    className="CancelUserView-button mt-0"
                    type="button" // Changed from submit to button
                  >
                    {t(translationConstants.cancel)}
                  </button>
                </div>
              </div>
            </>
          )
        )}
      </Form>{" "}
      <CustomModal
        size="lg"
        scrollable={true}
        setShow={onSetShowMap}
        show={isShowMap}
      >
        <FindOnMapModal
          setLng={setLng}
          setLat={setLat}
          lat={lat}
          lng={lng}
          handleSubmitLocation={handleSaveLocation}
        />
      </CustomModal>
    </div>
  );
};

export default ViewSpotModal;
